module.exports = __webpack_public_path__ + "img/id6.b5bff321.png";